/* Mod City Madness product page: gallery label card, photo strip, sticky buy bar */
(function(){
  if(window.__mcmBuy)return;window.__mcmBuy=1;
  function card(){
    var start=document.getElementById('mcmLabel'),end=document.getElementById('mcmAsk');
    end=end?end.closest('form')||end:document.querySelector('.mcm-foot');
    if(!start||!end||start.parentNode!==end.parentNode)return;
    var wrap=document.createElement('div');wrap.className='mcm-card';
    start.parentNode.insertBefore(wrap,start);
    var n=start;while(n){var next=n.nextSibling;wrap.appendChild(n);if(n===end)break;n=next;}
  }
  function strip(){
    var list=document.querySelector('.product__media-wrapper .product__media-list');
    if(!list)return;
    var items=[].slice.call(list.children).filter(function(li){return li.offsetParent!==null||li.classList.contains('product__media-item')});
    if(items.length<2)return;
    var s=document.createElement('div');s.className='mcm-strip';s.setAttribute('aria-label','Photos');
    items.forEach(function(li,i){var b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Photo '+(i+1)+' of '+items.length);
      b.addEventListener('click',function(){list.scrollTo({left:li.offsetLeft-list.offsetLeft,behavior:'smooth'})});s.appendChild(b);});
    var slider=list.closest('slider-component')||list;
    slider.parentNode.insertBefore(s,slider.nextSibling);
    document.body.classList.add('mcm-has-strip');
    var bs=s.children;
    function upd(){var w=list.clientWidth||1,i=Math.round(list.scrollLeft/w);if(i>bs.length-1)i=bs.length-1;
      for(var k=0;k<bs.length;k++)bs[k].setAttribute('aria-current',String(k===i));}
    list.addEventListener('scroll',upd,{passive:true});upd();
  }
  function bar(){
    var btn=document.querySelector('.product__info-container .product-form__submit')||document.querySelector('.product-form__submit');
    if(!btn)return;
    var bar=document.createElement('div');bar.className='mcm-buybar';bar.setAttribute('aria-hidden','true');
    bar.innerHTML='<div class="mcm-buybar__info"><span class="mcm-buybar__price"></span><span class="mcm-buybar__cond"></span></div><button type="button" class="mcm-buybar__btn" tabindex="-1"></button>';
    document.body.appendChild(bar);
    var bp=bar.querySelector('.mcm-buybar__price'),bc=bar.querySelector('.mcm-buybar__cond'),bb=bar.querySelector('.mcm-buybar__btn');
    function sync(){
      var now=document.getElementById('mcmPriceNow'),note=document.getElementById('mcmPriceNote');
      var pr=now?now.textContent.trim():((document.querySelector('.price-item--sale:not(:empty), .price-item--regular')||{}).textContent||'').trim();
      bp.textContent=pr;bc.textContent=note?note.textContent.trim():'';
      var label=(btn.querySelector('span')||btn).textContent.trim();
      bb.textContent=btn.disabled?label:'Add to cart';bb.disabled=!!btn.disabled;
    }
    bb.addEventListener('click',function(){if(!btn.disabled)btn.click()});
    /* only after the shopper has scrolled past the main button */
    function show(){var r=btn.getBoundingClientRect(),on=r.bottom<0;bar.classList.toggle('show',on);document.body.classList.toggle('mcm-buybar-on',on)}
    window.addEventListener('scroll',show,{passive:true});window.addEventListener('resize',show);
    document.addEventListener('change',function(e){if(e.target&&e.target.name==='mcm-cond')setTimeout(sync,60)});
    new MutationObserver(sync).observe(btn,{attributes:true,childList:true,subtree:true,characterData:true});
    sync();show();
  }
  function init(){try{card()}catch(e){}try{strip()}catch(e){}try{bar()}catch(e){}}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
